module.exports = __webpack_public_path__ + "1384e4ba8a472862cdc7469e7c8ead98.webp";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/LynksExport/assets/Sec-2/icon_1.webp
// module id = ./app/containers/StaticPage/LynksExport/assets/Sec-2/icon_1.webp
// module chunks = 40